import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Modal } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpand } from '@fortawesome/free-solid-svg-icons';
import '../../../theme/Layout/ChartConfig';
import {
  ChartCard,
  ChartCardHeader,
  ChartCardTitle,
  ChartCardSubtitle,
  ChartCardActions,
  ExpandButton,
  ChartCanvasContainer,
  ModalChartContainer,
  ModalSubtitle,
  StyledSelect,
} from './Styles';
import { PERIOD_FILTER_OPTIONS } from './Constant';
import PlatformFilterDropdown from './PlatformFilterDropdown';
import type { OrdersByHourCardProps } from './types';

const OrdersByHourCard: React.FC<OrdersByHourCardProps> = ({ data, isDarkMode = false }) => {
  const [period, setPeriod] = useState('weekly');
  const [channel, setChannel] = useState('all');
  const [expanded, setExpanded] = useState(false);

  const gridColor = isDarkMode ? '#2d3748' : '#f0f0f0';
  const tickColor = isDarkMode ? '#a0aec0' : '#718096';

  const chartData = {
    labels: data.map((point) => point.label),
    datasets: [
      {
        label: 'Orders',
        data: data.map((point) => point.value),
        backgroundColor: '#1890ff',
        hoverBackgroundColor: '#0f6dbf',
        borderRadius: 6,
        maxBarThickness: 36,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: isDarkMode ? '#1a202c' : '#fff',
        titleColor: isDarkMode ? '#fff' : '#1a202c',
        bodyColor: isDarkMode ? '#fff' : '#1a202c',
        borderColor: isDarkMode ? '#4a5568' : '#e2e8f0',
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: tickColor, font: { size: 11 } },
      },
      y: {
        grid: { color: gridColor },
        ticks: { color: tickColor, font: { size: 11 }, precision: 0 },
      },
    },
  };

  return (
    <ChartCard>
      <ChartCardHeader>
        <div>
          <ChartCardTitle>Orders by Hour</ChartCardTitle>
          <ChartCardSubtitle>Busiest hours today</ChartCardSubtitle>
        </div>
        <ChartCardActions>
          <ExpandButton aria-label="Expand chart" onClick={() => setExpanded(true)}>
            <FontAwesomeIcon icon={faExpand} />
          </ExpandButton>
          <PlatformFilterDropdown value={channel} onChange={setChannel} />
          <StyledSelect
            value={period}
            onChange={setPeriod}
            options={PERIOD_FILTER_OPTIONS}
            dropdownStyle={{ borderRadius: 12, overflow: 'hidden' }}
          />
        </ChartCardActions>
      </ChartCardHeader>

      <ChartCanvasContainer>
        <Bar data={chartData} options={options} />
      </ChartCanvasContainer>

      <Modal open={expanded} onCancel={() => setExpanded(false)} footer={null} title="Orders by Hour" width={860}>
        <ModalSubtitle>Busiest hours today</ModalSubtitle>
        <ModalChartContainer>
          <Bar data={chartData} options={options} />
        </ModalChartContainer>
      </Modal>
    </ChartCard>
  );
};

export default OrdersByHourCard;
